import React, { useState } from "react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Copy, Check, Terminal } from "lucide-react";

const ENDPOINT = "https://api.etelecom.in/v1/whatsapp/messages";

const SNIPPETS = {
  cURL: `curl -X POST ${ENDPOINT} \\
  -H "Authorization: Bearer YOUR_API_KEY" \\
  -H "Content-Type: application/json" \\
  -d '{
    "to": "+919852805552",
    "type": "template",
    "template": "order_update",
    "variables": { "1": "#4821", "2": "Out for delivery" }
  }'`,
  "Node.js": `import fetch from "node-fetch";

await fetch("${ENDPOINT}", {
  method: "POST",
  headers: {
    Authorization: "Bearer YOUR_API_KEY",
    "Content-Type": "application/json",
  },
  body: JSON.stringify({
    to: "+919852805552",
    type: "template",
    template: "order_update",
    variables: { "1": "#4821", "2": "Out for delivery" },
  }),
});`,
  Python: `import requests

requests.post(
    "${ENDPOINT}",
    headers={"Authorization": "Bearer YOUR_API_KEY"},
    json={
        "to": "+919852805552",
        "type": "template",
        "template": "order_update",
        "variables": {"1": "#4821", "2": "Out for delivery"},
    },
)`,
  Java: `HttpRequest req = HttpRequest.newBuilder()
  .uri(URI.create("${ENDPOINT}"))
  .header("Authorization", "Bearer YOUR_API_KEY")
  .header("Content-Type", "application/json")
  .POST(HttpRequest.BodyPublishers.ofString(
    "{\\"to\\":\\"+919852805552\\",\\"type\\":\\"template\\",\\"template\\":\\"order_update\\"}"))
  .build();`,
};

const LANGS = ["cURL", "Node.js", "Python", "Java"];

/**
 * Developer API integration block with language tabs + copy button.
 * Endpoint is an illustrative demo placeholder until the live API is published.
 */
export const ApiTabs = () => {
  const [copied, setCopied] = useState(false);
  const copy = async (code) => {
    try {
      await navigator.clipboard.writeText(code);
      setCopied(true);
      setTimeout(() => setCopied(false), 1600);
    } catch (e) {}
  };
  return (
    <div className="rounded-2xl bg-[#071427] border border-white/10 shadow-[0_18px_60px_rgba(2,6,23,0.35)] overflow-hidden" data-testid="whatsapp-api-tabs">
      <Tabs defaultValue="cURL" className="w-full">
        <div className="flex items-center gap-2 px-3 py-2.5 border-b border-white/10">
          <Terminal className="h-4 w-4 text-slate-400" />
          <TabsList className="bg-white/5 h-8">
            {LANGS.map((l) => (
              <TabsTrigger key={l} value={l} className="text-[11px] px-2.5 data-[state=active]:bg-white/10 data-[state=active]:text-white text-slate-400">{l}</TabsTrigger>
            ))}
          </TabsList>
        </div>
        {LANGS.map((l) => (
          <TabsContent key={l} value={l} className="m-0">
            <div className="relative">
              <button onClick={() => copy(SNIPPETS[l])} aria-label="Copy code" className="absolute right-3 top-3 z-10 inline-flex items-center gap-1.5 rounded-lg bg-white/5 px-2.5 py-1 text-[11px] font-medium text-slate-300 hover:bg-white/10 transition-colors">
                {copied ? <><Check className="h-3.5 w-3.5 text-green-400" /> Copied</> : <><Copy className="h-3.5 w-3.5" /> Copy</>}
              </button>
              <pre className="overflow-x-auto p-4 pt-10 text-[12px] leading-relaxed font-mono text-slate-200"><code>{SNIPPETS[l]}</code></pre>
            </div>
          </TabsContent>
        ))}
      </Tabs>
      <div className="px-4 py-2 border-t border-white/10 text-[10px] text-slate-500 font-mono">Illustrative endpoint for demonstration · live API details provided on onboarding</div>
    </div>
  );
};
